import CarouselContainer from "../../components/bonusUi/carousel";

const Carousel = () => {
  return <CarouselContainer />;
};

export default Carousel;
